export default __webpack_public_path__ + "images/ff9dbcb0be62d0b754724427d1a6a938-building_a_support_system.svg";